import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-onboarding-welcome-back',
  templateUrl: './onboarding-welcome-back.component.html',
  styleUrls: ['./onboarding-welcome-back.component.scss'],
})
export class OnboardingWelcomeBackComponent {
  constructor(private modalCtrl: ModalController) {}

  continue(): void {
    this.modalCtrl.dismiss({ startOver: false });
  }

  startOver(): void {
    this.modalCtrl.dismiss({ startOver: true });
  }
}
